
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiColdGoogle as ObiColdGoogleElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-cold-google.js';
 
 
 

 
 export const ObiColdGoogle = createComponent({
   react: React,
   tagName: 'obi-cold-google',
   elementClass: ObiColdGoogleElement,
   events: {
     
   }
  });
 
 